export { default as SwitchHorizontalSolidIcon } from './SwitchHorizontalSolidIcon';
